module.exports = __webpack_public_path__ + "static/media/gatsby.68625561.png";